import type { FunctionComponent } from 'react';

import { useGameConfig } from '../../config/GameConfigProvider';
import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { CurrencyConnected } from '../currency/CurrencyConnected';
import { Modal } from '../modal/modal';
import { L12nText } from '../text/L12nText';

import styles from './BetLimits.module.css';

export interface BetLimitModalConnectedProps {}

export const BetLimitModalConnected: FunctionComponent<BetLimitModalConnectedProps> = () => {
  const dispatch = useCoreDispatch();
  const open = useHeaderSlice.getCoreBetLimitsOpen();
  const tableName = useConfigSlice.tableName() as string;
  const tableBetLimits = useConfigSlice.tableBetLimits();
  const { betLimitContent } = useGameConfig();

  return (
    <Modal
      open={open}
      onClose={(): void => {
        dispatch(headerActions.setBetLimitsOpen(!open));
      }}
      fullScreenNoClose
      floating
      placement="start"
      title={<L12nText tk="BETLIMITSANDPAYOUTS" />}
    >
      <div className={styles.betLimits_mobile_title}>
        <L12nText tk={tableName} /> <CurrencyConnected value={tableBetLimits?.min || 0} avoidTrailingZero /> -{' '}
        <CurrencyConnected value={tableBetLimits?.max || 0} avoidTrailingZero />
      </div>
      {betLimitContent}
    </Modal>
  );
};
